"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const admin_service_g_1 = require("./admin-service.g");
class AdminService extends admin_service_g_1.AdminService {
    updateUserPhotoWithFileType(params) {
        this.setContentType(params);
        return this.updateUserPhoto(params);
    }
    updateUserPhotoByAccountIdWithFileType(params) {
        this.setContentType(params);
        return this.updateUserPhotoByAccountId(params);
    }
    updateGroupPhotoByAccountIdWithFileType(params) {
        this.setContentType(params);
        return this.updateGroupPhotoByAccountId(params);
    }
    updateGroupPhotoWithFileType(params) {
        this.setContentType(params);
        return this.updateGroupPhoto(params);
    }
    updateContactPhotoWithFileType(params) {
        this.setContentType(params);
        return this.updateContactPhoto(params);
    }
    updateContactPhotoByAccountIdWithFileType(params) {
        this.setContentType(params);
        return this.updateContactPhotoByAccountId(params);
    }
    setContentType(params) {
        params.options = params.options || {};
        const headerParameter = {};
        params.options.headers = Object.assign({}, headerParameter, params.options.headers);
        if (!params.options.headers['content-type']) {
            params.options.headers['content-type'] = params.fileType;
        }
    }
}
exports.AdminService = AdminService;
